export default __webpack_public_path__ + "static/design-tokens-explainer-06bd71a0dd8a758a635f25fa59df2af8.png";